exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-tab[data-v-3192753e]{background-color:#ece4df;color:#3c47d1!important;font-weight:700}.v-tab[data-v-3192753e]{text-transform:none;justify-content:start;font-size:16px;letter-spacing:normal;height:35px}", ""]);

// exports
